//list of available filter keys

const filterKeyBetRecordData = {
  START_DATE: "start_date",
  END_DATE: "end_date",
  GAME_CODE: "game_code",
  GAME_SUB_CODE: "game_sub_code",
  GAME_ID: "game_id",
  CATEGORY_ID: "category_id",
  ACCOUNT: "account",
  UPPER_ACCOUNT: "upper_agent_account",
};

export { filterKeyBetRecordData };
